import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, styled, TextField, type TextFieldProps } from "~/common/mui";

export type SearchInputGroupTextFieldProps = Omit<TextFieldProps, "variant"> & {
  clearable?: boolean;
};

const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiInputBase-root": {
    backgroundColor: "transparent",
  },
});

export const SearchInputGroupTextField = ({
  clearable = true,
  value,
  defaultValue,
  onChange,
  InputProps,
  ...props
}: SearchInputGroupTextFieldProps) => {
  const isControlled = value !== undefined;
  const [internalValue, setInternalValue] = useState(defaultValue ?? "");

  const currentValue = isControlled ? value : internalValue;
  const showClear = clearable && !!currentValue;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!isControlled) {
      setInternalValue(e.target.value);
    }
    onChange?.(e);
  };

  const handleClear = () => {
    if (!isControlled) {
      setInternalValue("");
    }
    const fakeEvent = { target: { value: "" } } as React.ChangeEvent<HTMLInputElement>;
    onChange?.(fakeEvent);
  };

  return (
    <StyledTextField
      variant="outlined"
      value={isControlled ? value : internalValue}
      onChange={handleChange}
      InputProps={{
        ...InputProps,
        endAdornment: showClear ? (
          <IconButton size="small" onClick={handleClear} edge="end">
            <CloseIcon fontSize="small" />
          </IconButton>
        ) : (
          InputProps?.endAdornment
        ),
      }}
      {...props}
    />
  );
};
